import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import Obvious1 from "../images/obvious_1.jpg"
import Obvious2 from "../images/obvious_2.jpg"
import Obvious3 from "../images/obvious_3.jpg"
import Obvious4 from "../images/obvious_4.jpg"
import Obvious5 from "../images/obvious_5.jpg"

const Obvious = () => (
  <Layout>
    <SEO title="Obvoius" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader title="Obvious Portal" subtitle="Front-end | Design" />
      <ProductSection image={Obvious5} />
      <ProductSection image={Obvious1} />
      <ProductSection image={Obvious2} />
      <ProductSection image={Obvious3} />
      <ProductSection image={Obvious4} />
    </div>
  </Layout>
)

export default Obvious
